import type { QueryClient } from "@tanstack/react-query";
import type { RouteObject } from "react-router-dom";

import { MainLayout } from "@/components/organisms/Layout/MainLayout";
import { routePaths } from "@/config/route-paths";
import { RequireRole } from "@/features/auth";
import { handleDynamicImportError } from "@/lib/react-router";
import { convert } from "@/lib/react-router-convert";

export const TenantManagementRoutes: (
  queryClient: QueryClient
) => RouteObject[] = (queryClient: QueryClient) => [
  {
    element: <MainLayout isExpand />,
    children: [
      {
        // テナントに属さない運営者の世界。API がホスト限定のため他ロールは入れない
        element: <RequireRole allow={["host"]} />,
        children: [
          {
            path: routePaths.admin.tenants.path,
            lazy: () =>
              import("./tenant-list-route")
                .then((m) => ({ default: m.TenantListRoute }))
                .then(convert(queryClient))
                .catch((error) =>
                  handleDynamicImportError({
                    componentName: "tenant-management/routes/tenant-list-route",
                    error,
                  })
                ),
          },
        ],
      },
    ],
  },
];
